module.exports = __webpack_public_path__ + "static/media/dock-cleat.bbbccbd1.png";